<cmps-dialog class="cmps-trend-view-dialog--dialog">
    <cmps-dialog-body>
        <div class="chart-header-container">
            <span class="chart-header-label">
                {{ _trendData?.trendTitle }}
            </span>
            <button
                class="cmps-button--no-bg chart-header-close-btn"
                cmpsButton
                (click)="_onCloseClick()"
            >
                <cmps-icon svgIcon="close"></cmps-icon>
            </button>
        </div>
        <div class="trend-chart-wrapper">
            <span
                class="trend-chart--y-axis-title"
                *ngIf="_trendData?.paths?.[0].points.length > 0"
            >
                {{ _trendData?.yAxisTitle }}
            </span>
            <cmps-mi2-trend-dialog></cmps-mi2-trend-dialog>
        </div>

        <span
            class="trend-chart--x-axis-title"
            *ngIf="_trendData?.paths?.[0].points.length > 0"
        >
            {{ _i18n._828_MONTH | translate }}
        </span>

        <div class="legends-wrapper">
            <div
                class="legend-container"
                *ngFor="let legend of _trendData?.legends"
            >
                <ng-container>
                    <div
                        class="legend"
                        [style.background-color]="legend.color"
                    ></div>
                    <span class="legend-label">{{ legend.label }}</span>
                </ng-container>
            </div>
        </div>
    </cmps-dialog-body>
</cmps-dialog>
